import React from 'react';
import { NetworkWiredIcon } from '@patternfly/react-icons';
import NetworkApplianceTab from './NetworkApplianceTab';

function SwitchesTab() {
  return (
    <NetworkApplianceTab
      resource="switches"
      nounPlural="switches"
      emptyIcon={NetworkWiredIcon}
      tableAriaLabel="Switches list"
    />
  );
}

export default SwitchesTab;
